<div class="container-dialog">
  <div class="container-dialog__body">
    <p>{{ data.content }}</p>
  </div>
  <div class="container-dialog__footer">
    <button class="bdr-btn bdr-btn-white" (click)="onChooseOption(false)">Cancelar</button>
    <button class="bdr-btn bdr-btn-blue" (click)="onChooseOption(true)">Aceptar</button>
  </div>
</div>